var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"403","title":"403","sub-title":"您无权限访问此页面，如有疑问请联系管理人员"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.toIndex}},[_vm._v(" 回到主页 ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }